import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import {GetMessagingAdsListUserRequest} from '../Requests/GetMessagingAdsListUserRequest.js'
import UserServicesFactory from '../Services/factory.js'

class GetMessagingAdsListUserUseCase extends UseCase {
  #config
  #repository
  #currentUserService
  #userNotLoggedInUserError

  constructor({config, repository, currentUserService, userNotLoggedInUserError}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#currentUserService = currentUserService
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new GetMessagingAdsListUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      currentUserService: UserServicesFactory.getCurrentUserService({config}),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'GetMessagingAdsListUserUseCase#execute'})
  @AsyncInlineError()
  async execute({adIds}) {
    const request = GetMessagingAdsListUserRequest.create({adIds})

    const [error, response] = await this.#repository.getMessagingAdsList({
      request,
      adIds
    })
    return error ? Promise.reject(error) : response.toJSON()
  }
}

export const factory = GetMessagingAdsListUserUseCase.create
